module.exports = "@media (min-width: 1200px) {\n  .lg-info.condensed section {\n    width: 1200px;\n    margin: 0 auto; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/distributor/containers/employee-profile/employee-profile.component.scss
// module id = ./src/app/distributor/containers/employee-profile/employee-profile.component.scss
// module chunks = main